import React, { useRef } from 'react';
import LibraryDialog from './LibraryDialog';

/**
 * Archiving asks first (PRD-1607). It says the item moves to Archived and can
 * be unarchived, with Cancel and a destructive "Archive {kind}" ("Archive
 * document" by default). Focus
 * starts on Cancel, not on the destructive action. Scenarios use it too
 * (PRD-1701), as `kind="scenario"`.
 */
function ArchiveConfirmDialog({ item, kind = 'document', opener, fallbackFocus, onConfirm, onClose }) {
  const cancelRef = useRef(null);
  return (
    <LibraryDialog
      title={`Archive ${kind}?`}
      size="confirm"
      initialFocus={cancelRef}
      opener={opener}
      fallbackFocus={fallbackFocus}
      onClose={onClose}
    >
      <p className="library-dialog-text">{item.name} moves to Archived. You can unarchive it at any time.</p>
      <div className="library-dialog-actions">
        <button ref={cancelRef} type="button" className="resui-btn resui-btn--secondary" onClick={onClose}>Cancel</button>
        <button type="button" className="resui-btn resui-btn--destructive" onClick={onConfirm}>Archive {kind}</button>
      </div>
    </LibraryDialog>
  );
}

export default ArchiveConfirmDialog;
